import { render, staticRenderFns } from "./TicketTypeCreateModal.vue?vue&type=template&id=6a8b3f2a&scoped=true"
import script from "./TicketTypeCreateModal.vue?vue&type=script&lang=js"
export * from "./TicketTypeCreateModal.vue?vue&type=script&lang=js"
import style0 from "./TicketTypeCreateModal.vue?vue&type=style&index=0&id=6a8b3f2a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../.worktrees/accreditations-staging-e2e-fix/frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a8b3f2a",
  null
  
)

export default component.exports